import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import NewModal from '../NewModal';
import MessageCard from './MessageCard';

const MessageModal = ({ open, bDel, items, onUpdate, onCancel }) => {
  const [selected, setSelected] = useState(items.map(({ id }) => id));
  const updateButtons = [
    { label: '취소', onClick: onCancel },
    {
      label: bDel ? '선택 삭제' : '선택 재전송',
      color: bDel && 'error',
      onClick: () => onUpdate(selected),
    },
  ];

  const onChange = (e, id) => {
    const selectedIndex = selected.indexOf(id);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  return (
    <NewModal open={open} buttons={updateButtons} onClose={onCancel}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5">
            {bDel
              ? '다음과 같이 선택 된 메시지를 삭제합니다.'
              : '다음과 같이 선택 된 메시지를 재전송합니다.'}
          </Typography>
        </Grid>
        {items &&
          items.map((item) => (
            <Grid item xs={items.length === 1 ? 12 : 6} key={item.id}>
              <MessageCard
                {...item}
                edit
                checked={selected.indexOf(item.id) > -1}
                item={[item]}
                onChange={(e) => onChange(e, item.id)}
              />
            </Grid>
          ))}
      </Grid>
    </NewModal>
  );
};

export default MessageModal;
